export default "__VITE_ASSET__d57f2fc1__"